import Vue from 'vue';
import dayjs from 'dayjs';
import { mutationTypes } from '@/types';
import logger from '@/tools/logger';

export default async function loadCalendar({ state, getters, commit }, { language } = {}) {
	if (!state.dataSourceCFG.global.showCalendar) return;
	let url;
	try {
		// get calendar package url
		const calendarURL = state.dataSourceCFG.offlineAppWithVersionProviderInit.find((element) =>
			/^calendar-/.test(element.name)
		).name;
		url = new URL(`./apps/${calendarURL}/${language || getters.currentLanguage}.json`, state.dataSourceURL);
		const { body } = await Vue.http.get(url.toString());
		const today = dayjs().startOf('day');
		commit(mutationTypes.setCalendarEvents, {
			calendarEvents: body
				// Remove events that are older than current day.
				.filter((event) => !dayjs(event.date).isBefore(today))
				.map((event) => Object.assign(event, { date: new Date(event.date), triggers: [] })),
		});
	} catch (error) {
		logger.error(`Could not initialise calendar at ${url}`);
	}
}
